// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtm from 'vue-gtm'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import App from './App'
import router from '@/router'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
// axios.defaults.withCredentials = true

// GTM
Vue.use(VueGtm, {
  // container id
  id: 'GTM-TBKJZVX',
  // enable track or not (optional)
  // enabled: true,
  enabled: process.env.NODE_ENV === 'production',
  // display console logs debugs or not (optional)
  debug: false,
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
})

// BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: `<App/>`
})



// WEBPACK FOOTER //
// ./src/main.js